import moment from "moment";

export const PAGE_SIZE = 10;

// Normalize a reducer error (string | string[] | {field:[msg]}) into a flat message list.
export const toMessages = (error, fallback = "Something went wrong.") => {
  if (!error) return [fallback];
  if (Array.isArray(error)) {
    const flat = error.filter(Boolean);
    return flat.length ? flat : [fallback];
  }
  if (typeof error === "string") return [error];
  if (typeof error?.message === "string") return [error.message];
  // Field-error map -> flatten values.
  if (typeof error === "object") {
    const msgs = [];
    Object.values(error).forEach((v) => {
      if (Array.isArray(v)) v.forEach((m) => m && msgs.push(m));
      else if (typeof v === "string") msgs.push(v);
    });
    return msgs.length ? msgs : [fallback];
  }
  return [fallback];
};

export const formatDate = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("ll") : "—";
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("lll") : "—";
};

// Group a flat permission catalogue by `domain`, sorted; items sorted by action then name.
const ACTION_ORDER = { view: 0, create: 1, edit: 2, delete: 3 };

export const groupByDomain = (catalogue = []) => {
  const byDomain = {};
  catalogue.forEach((perm) => {
    const domain = perm?.domain || "other";
    if (!byDomain[domain]) byDomain[domain] = [];
    byDomain[domain].push(perm);
  });
  return Object.keys(byDomain)
    .sort()
    .map((domain) => ({
      domain,
      permissions: byDomain[domain].sort((a, b) => {
        const ao = ACTION_ORDER[a?.action] ?? 99;
        const bo = ACTION_ORDER[b?.action] ?? 99;
        if (ao !== bo) return ao - bo;
        return (a?.name || "").localeCompare(b?.name || "");
      }),
    }));
};

export const prettyDomain = (domain) => {
  if (!domain) return "Other";
  return domain
    .toString()
    .replace(/[_-]+/g, " ")
    .replace(/(^|\s)\w/g, (s) => s.toUpperCase());
};

// The catalogue prefixes dashboard-only descriptions with "[dashboard-only] ";
// strip it for display since we render a separate tag for that state.
export const cleanPermissionLabel = (perm) => {
  const desc = perm?.description || perm?.name || "";
  return desc.replace(/^\s*\[dashboard-only\]\s*/i, "").trim() || perm?.name || "";
};

export const memberFullName = (member) => {
  const name = [member?.first_name, member?.last_name].filter(Boolean).join(" ").trim();
  return name || member?.email || "—";
};
